'use client';

import { useHandleIFrameMessages } from '@/hooks/useHandleIFrameMessages';
import { useMessagesToHostScript } from '@/hooks/useIframeMessages';
import { cn } from '@/lib/utils';
import { X } from '@phosphor-icons/react';
import Image from 'next/image';
import { Button } from '../ui/button';
function Header({
  replicaImage,
  replicaName,
  replicaDescription,
  className,
  ref
}: {
  replicaImage?: string;
  replicaName?: string;
  replicaDescription?: string | null;
  className?: string;
  ref?: React.RefObject<HTMLDivElement | null>;
}) {
  const {
    handleClose
  } = useMessagesToHostScript();
  const {
    config
  } = useHandleIFrameMessages({
    onSuggestedQuestion: () => {}
  });
  const displayName = config?.name || replicaName;
  const displayDescription = config?.description || replicaDescription;
  const displayImage = config?.profileImage || replicaImage;
  return <div ref={ref} className={cn('header-background backdrop-blur-[18px] py-3 px-4 w-full z-10', className)} data-sentry-component="Header" data-sentry-source-file="header.tsx">
      <div className="flex items-center gap-2">
        {displayImage && displayName && <>
            <div className="relative rounded-full shrink-0 h-10 w-10 overflow-hidden bg-foreground/5">
              <Image src={displayImage as string} alt={displayName as string} className="object-cover" fill={true} />
            </div>

            <div className="space-y-1">
              <p className="text-foreground font-semibold leading-none">{displayName}</p>
              {displayDescription && <p className="text-foreground/50 text-sm leading-none">{displayDescription}</p>}
            </div>
          </>}

        <Button aria-label="Close Chat" variant="ghost" size="icon" onClick={handleClose} className="ml-auto cursor-pointer text-foreground/50 hover:text-foreground" data-sentry-element="Button" data-sentry-source-file="header.tsx">
          <X weight="bold" className="size-4" data-sentry-element="X" data-sentry-source-file="header.tsx" />
        </Button>
      </div>
    </div>;
}
export default Header;